export enum BmReportsAutoCounterResetMessages {
  MODAL_TITLE = 'Update Student(s) Counter',
  MODAL_SUBTITLE = 'Update the automation group counter for the behavior(s) triggering its automations',
  COUNTER_LABEL = 'New automation counter value',
  BUTTON_LABEL_CANCEL = 'Cancel',
  BUTTON_LABEL_UPDATE = 'Update',
}
